import React from "react";
import "./ReveAquatique.scss";

const ReveAquatique = () => {
  return (
    <div className="reve-container">
      <div className="text-section">
        <h1 data-aos="fade-down" data-aos-duration="1000" data-aos-offset="200">
          L'art de la piscine, sur mesure pour vous.
        </h1>

        <p data-aos="fade-right" data-aos-duration="1000" data-aos-offset="200">
          <strong>SBHM Concept</strong>, avec plus d'une décennie de maîtrise et
          spécialisé dans la construction et la rénovation de piscines de
          qualité. Nous offrons des solutions personnalisées qui répondent à vos
          envies.
        </p>

        <p data-aos="fade-left" data-aos-duration="1000" data-aos-offset="200">
          Nos réalisations en béton et coque sont non seulement durables, mais
          également pensées pour s'intégrer harmonieusement à votre espace
          extérieur.
        </p>

        <p data-aos="fade-right" data-aos-duration="1000" data-aos-offset="100">
          Notre engagement vers l’excellence garantit des produits fiables et
          esthétiques.
        </p>

        <p data-aos="fade-left" data-aos-duration="1000" data-aos-offset="100">
          Que vous souhaitiez créer un havre de paix ou un espace de
          divertissement, nous sommes là pour réaliser votre rêve.
        </p>
      </div>

      <div
        className="image-section"
        data-aos="fade-left"
        data-aos-duration="1000"
        data-aos-offset="200"
      >
        <img
          loading="lazy"
          src="/img/photo6.jpg"
          alt="piscine avec une femme qui a les pieds dedans"
        />
      </div>
    </div>
  );
};

export default ReveAquatique;
